import CardComponent from "./CardComponent";

export class CategoryBullets extends CardComponent {

}
